import { render, staticRenderFns } from "./perbelanjaanDaerahStrata.vue?vue&type=template&id=4afa3ffe&scoped=true"
import script from "./perbelanjaanDaerahStrata.vue?vue&type=script&lang=js"
export * from "./perbelanjaanDaerahStrata.vue?vue&type=script&lang=js"
import style0 from "./perbelanjaanDaerahStrata.vue?vue&type=style&index=0&id=4afa3ffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afa3ffe",
  null
  
)

export default component.exports